import { Outlet } from "react-router-dom";

// A navegação entre Usuários e Permissões deixou de ser feita por abas aqui e
// passou a ser feita pelos sub-itens da aba "Administração" na sidebar
// (pages/client/layout), no mesmo padrão do lado interno
// (/interno/administracao → Usuários/Auditoria/Integração ERP/Geral).
export default function AdministracaoCliente() {
  return <Outlet context={[]} />;
}
